import { Pipe, PipeTransform } from '@angular/core';
import { IWelcomeGroupingStatRow } from 'src/app/info/welcome-grouping-stat.model';

@Pipe({
  name: 'groupingStatTotal',
  pure: true,
})
export class GroupingStatTotalPipe implements PipeTransform {
  transform(rows: IWelcomeGroupingStatRow[] | null | undefined): number {
    if (!rows) return 0;
    return rows.reduce((sum, row) => sum + (row.Count || 0), 0);
  }
}
